import type { PlayerStandingRow } from '@league/shared/contract';
import { isLeader } from '@league/shared/scoring';

/**
 * The top five places, each on at least 25 points (Courtney, 2026-10-12) — the same `isLeader` the
 * API trims with, so the screen and the server cannot disagree about who is a leader. Competitive
 * ranks are preserved; names only order players within an already shared place.
 */
export function standingLeaders(rows: PlayerStandingRow[]) {
  return rows.filter(isLeader).sort((a, b) => a.rank - b.rank || a.name.localeCompare(b.name));
}
